import { Metamodel } from 'app/model/base/model';
import { BlobTypeStoreReadSettings } from './blob-type-store-read-settings';
import { AzureDataLakeStoreLinkedService } from 'app/model/linkedservice/azure-data-lake-store.linkedservice';
import { IModel, IAttribute, stringIsNullOrEmpty, IViolation } from 'shell-models-lib';

import { format } from 'app/shared/utils/string.util';
import { FilePathMode } from 'app/registries/consts/metadata-consts';
import { StoreReadSettings } from './store-read-settings';

@Metamodel.model({
    name: 'AzureDataLakeStoreReadSettings',
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(AzureDataLakeStoreLinkedService)
    }
})

export class AzureDataLakeStoreReadSettings extends BlobTypeStoreReadSettings {
    public static readonly MODEL: IModel;
    public static readonly LIST_BEFORE: IAttribute;
    public static readonly LIST_AFTER: IAttribute;
    public supportedFilePathMode = [
        FilePathMode.DATASET,
        FilePathMode.NameRange,
        FilePathMode.WILDCARD,
        FilePathMode.LIST
    ];

    @Metamodel.attribute({
        display: stringResources.ModelName_ListBefore,
        association: 'LIST_BEFORE',
        templatable: true,
        constraint: {
            validator: AzureDataLakeStoreReadSettings.validateListBeforeAndAfter
        }
    })
    public listBefore?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ListAfter,
        association: 'LIST_AFTER',
        templatable: true,
        constraint: {
            validator: AzureDataLakeStoreReadSettings.validateListBeforeAndAfter
        }
    })
    public listAfter?: string;

    private static async validateListBeforeAndAfter(storeSettings: AzureDataLakeStoreReadSettings, beforeOrAfter: string): Promise<IViolation[] | undefined> {
        if (storeSettings.filePathMode === FilePathMode.NameRange) {
            if (stringIsNullOrEmpty(storeSettings.listBefore) && stringIsNullOrEmpty(storeSettings.listAfter)
                && stringIsNullOrEmpty(AzureDataLakeStoreReadSettings.LIST_BEFORE.templateValue(storeSettings))
                && stringIsNullOrEmpty(AzureDataLakeStoreReadSettings.LIST_AFTER.templateValue(storeSettings))) {
                return [{
                    message: () => format(stringResources.ValidationError_EmptyFilePathTemplate,
                        `${stringResources.ModelName_ListBefore} ${stringResources.Or.toLocaleLowerCase()} ${stringResources.ModelName_ListAfter}`, stringResources.ModelName_ListBeofreAndAfterMode)
                }];
            } else if (!stringIsNullOrEmpty(beforeOrAfter) && beforeOrAfter.indexOf('/') !== -1) {
                return [{
                    message: () => stringResources.ADLS_ListBeforeAfter_Error
                }];
            }
        }
        return undefined;
    }

    public recoverPropFromPrevOne(prevStoreSettings: StoreReadSettings): void {
        super.recoverPropFromPrevOne(prevStoreSettings);
        this.updateModelValue('listBefore', this, prevStoreSettings);
        this.updateModelValue('listAfter', this, prevStoreSettings);
    }
}
